exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".loading-indicator--full-page[data-v-ec472474]{left:0;z-index:100}", ""]);

